// Wishlist Preferences v2 — Product Category multi-select (Feb 2026).
// Thin wrapper around CatalogMultiSelect that pre-wires:
//   • endpoint:        GET /catalog/product-categories
//   • label rendering: localised label_es | label_en (we DO translate categories)
//   • optional group filter (defaults OFF — see scope rule §6).

import React from "react";
import CatalogMultiSelect from "./CatalogMultiSelect";

const renderCategoryLabel = (it, lang) => {
  if (lang === "es" && it.label_es) return it.label_es;
  return it.label_en || it.key;
};

export const ProductCategoryMultiSelect = ({
  value,
  customValue,
  onChange,
  onCustomChange,
  t,
  lang = "en",
}) => {
  return (
    <CatalogMultiSelect
      endpoint="/catalog/product-categories"
      value={value || []}
      customValue={customValue || []}
      onChange={onChange}
      onCustomChange={onCustomChange}
      renderLabel={(it) => renderCategoryLabel(it, lang)}
      filterParamKey="group"
      filterValue=""
      t={t}
      testIdPrefix="wlp-category"
      label={t("settings.wishlistV2.categories.label")}
      placeholder={t("settings.wishlistV2.categories.placeholder")}
      searchPlaceholder={t("settings.wishlistV2.categories.searchPlaceholder")}
      searchEmpty={t("settings.wishlistV2.categories.searchEmpty")}
      otherLabel={t("settings.wishlistV2.categories.otherLabel")}
      otherPlaceholder={t("settings.wishlistV2.categories.otherPlaceholder")}
    />
  );
};

export default ProductCategoryMultiSelect;
